import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FaWhatsapp } from 'react-icons/fa';
import { FaMotorcycle } from 'react-icons/fa';
import TermsModal from './TermsModal';
import PrivacyPolicyModal from './PrivacyPolicyModal';

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const whatsappContact = "919390595210"
  const whatsappMessage = "Hi, I have the following enquiry.";
  const whatsappUrl = `https://wa.me/${whatsappContact}?text=${encodeURIComponent(whatsappMessage)}`;

  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  return (
    <footer>
        <Container>
            <Row>
                <Col className='text-center py-3'>
                    <p><strong>&copy;</strong> NCG Global Enterprises 2021 - {currentYear}</p>
                    <p>
                      <Link to="/contact" className="terms-text-link">
                        Contact Us
                      </Link>
                      &nbsp;| Contact on WhatsApp&nbsp;
                      <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                        <FaWhatsapp style={{ color: 'green', fontSize: '2rem', fontStyle: "bold" }}/>
                      </a>
                      &nbsp;|&nbsp;                    
                      <span
                        className="terms-text-link"
                        onClick={() => setShowTerms(true)}
                        role="button"
                        tabIndex={0}
                      >
                        Terms & Conditions
                      </span>
                      <TermsModal show={showTerms} onHide={() => setShowTerms(false)} />
                      &nbsp;|&nbsp;                    
                      <span
                        className="terms-text-link"
                        onClick={() => setShowPrivacyPolicy(true)}
                        role="button"
                        tabIndex={0}
                      >
                        Privacy Policy
                      </span>
                      <PrivacyPolicyModal show={showPrivacyPolicy} onHide={() => setShowPrivacyPolicy(false)} />
                      &nbsp;| Delivery Partner Portal&nbsp;
                      <a href='/deliverypartner' target="_blank" rel="noopener noreferrer">
                        <FaMotorcycle style={{ color: "#cc7722", fontSize: '2rem', fontStyle: "bold" }}/>
                      </a>
                    </p>
                </Col>
            </Row>
        </Container>
    </footer>
  )
}

export default Footer